import { n as c, b as a, t as _ } from "./element-CV9utnHJ.js";
import { e as u, n as d } from "./ref-Dma3n3i8.js";
import { o as n } from "./if-defined-rXcLNTzN.js";
import { r as $ } from "./state-l4hGZdFJ.js";
import { P as x } from "./input-element-BGNbdzy2.js";
import { P as m } from "./pkt-options-controller-Z-bPox7n.js";
import { P as b } from "./pkt-slot-controller-D7CrjM52.js";
import "./input-wrapper-CaUY90qz.js";
var P = Object.defineProperty, v = (e, t, s, o) => {
  for (var i = void 0, l = e.length - 1, p; l >= 0; l--)
    (p = e[l]) && (i = p(t, s, i) || i);
  return i && P(t, s, i), i;
};
class h extends x {
  constructor() {
    super(...arguments), this._optionsProp = [], this._options = [];
  }
  /**
   * Public getter for options that includes selected state
   * Override this in subclasses to customize the selected state logic
   */
  get options() {
    return this._options.map((t) => ({
      ...t,
      selected: this.isOptionSelected(t)
    }));
  }
  /**
   * Public setter for options
   */
  set options(t) {
    this._optionsProp = t, this.requestUpdate("_optionsProp", this._options);
  }
  /**
   * Determines if an option is selected
   * Subclasses should override this to implement their selection logic
   *
   * @param option - The option to check
   * @returns True if the option is selected
   * @protected
   */
  isOptionSelected(t) {
    return Array.isArray(this.value) ? this.value.includes(t.value) : t.value === this.value;
  }
  /**
   * Finds an option by its value
   *
   * @param value - The value to search for
   * @returns The option if found, undefined otherwise
   * @protected
   */
  findOptionByValue(t) {
    return this._options.find((s) => s.value === t);
  }
  /**
   * Gets all currently selected options
   *
   * @returns Array of selected options
   * @protected
   */
  getSelectedOptions() {
    return this._options.filter((t) => this.isOptionSelected(t));
  }
  /**
   * Parses options from either props or slot controller
   * Call this in connectedCallback to initialize options
   *
   * @protected
   */
  parseOptions() {
    var o, i;
    const t = this._optionsProp.length > 0, s = ((i = (o = this.optionsController) == null ? void 0 : o.nodes) == null ? void 0 : i.length) && this.optionsController.nodes.length > 0;
    t ? this._options = this._optionsProp : s && (this._options = this.optionsController.options);
  }
  /**
   * Re-parse options when the component updates
   * This ensures options stay in sync when they change dynamically
   *
   * @protected
   */
  willUpdate(t) {
    super.willUpdate(t), this.parseOptions();
  }
}
v([
  c({ type: Array, attribute: "options" })
], h.prototype, "_optionsProp");
v([
  $()
], h.prototype, "_options");
var g = Object.defineProperty, O = Object.getOwnPropertyDescriptor, f = (e, t, s, o) => {
  for (var i = o > 1 ? void 0 : o ? O(t, s) : t, l = e.length - 1, p; l >= 0; l--)
    (p = e[l]) && (i = (o ? p(t, s, i) : p(i)) || i);
  return o && i && g(t, s, i), i;
};
let r = class extends h {
  constructor() {
    super(), this.inputRef = u(), this.helptextSlot = u(), this.value = "", this.selectedIndex = -1, this.selectedOptions = void 0, this.optionsController = new m(this), this.slotController = new b(this, this.helptextSlot), this.slotController.skipOptions = !0;
  }
  connectedCallback() {
    super.connectedCallback(), this.parseOptions(), this._options.forEach((e) => {
      e.selected && !this.value && (this.value = e.value);
    });
  }
  // Support native Select method `add`
  add(e, t) {
    const s = {
      value: e.value || e.text,
      label: e.text || e.value,
      selected: e.selected,
      disabled: e.disabled
    };
    if (t === void 0)
      this._options.push(s);
    else if (typeof t == "number")
      this._options.splice(t, 0, s);
    else {
      const o = t.value || t.text, i = this._options.findIndex((l) => l.value === o);
      i >= 0 ? this._options.splice(i, 0, s) : this._options.push(s);
    }
    e.selected && (this.value = e.value || e.text, this.selectedIndex = this._options.findIndex((o) => o.value === this.value)), this.requestUpdate();
  }
  // Support native Select method `remove`
  remove(e) {
    var t;
    typeof e == "number" && (this.selectedIndex === e && (this.value = ((t = this._options[0]) == null ? void 0 : t.value) || ""), this._options.splice(e, 1), this.requestUpdate());
  }
  // Support native Select method `item`
  item(e) {
    var t;
    return (t = this.inputRef.value) == null ? void 0 : t.item(e);
  }
  // Support native Select method `namedItem`
  namedItem(e) {
    var t;
    return (t = this.inputRef.value) == null ? void 0 : t.namedItem(e);
  }
  // Support native Select method `showPicker`
  showPicker() {
    this.inputRef.value && "showPicker" in this.inputRef.value && this.inputRef.value.showPicker();
  }
  attributeChangedCallback(e, t, s) {
    var o, i;
    e === "options" && (this._options = s ? JSON.parse(s) : []), e === "value" && this.value !== t && (this.selectedIndex = this.touched ? this.returnNumberOrNull((o = this.inputRef.value) == null ? void 0 : o.selectedIndex) : this._options.findIndex((l) => l.value === s), this.selectedOptions = (i = this.inputRef.value) == null ? void 0 : i.selectedOptions, this.valueChanged(s, t)), super.attributeChangedCallback(e, t, s);
  }
  update(e) {
    var t, s;
    super.update(e), e.has("_optionsProp") && this._optionsProp.length > 0 && (this._options = this._optionsProp, this.requestUpdate("_options"), !this.value && this._options.length > 0 && (this.value = this._options[0].value, this.selectedIndex = 0)), e.has("value") && this.value !== e.get("value") && (this.selectedIndex = this.touched ? this.returnNumberOrNull((t = this.inputRef.value) == null ? void 0 : t.selectedIndex) : this._options.findIndex((o) => o.value === this.value), this.selectedOptions = (s = this.inputRef.value) == null ? void 0 : s.selectedOptions, this.valueChanged(this.value, e.get("value"))), e.has("id") && !this.name && this.id && (this.name = this.id);
  }
  firstUpdated(e) {
    var t;
    super.firstUpdated(e), this._optionsProp.length && (this._options = this._optionsProp), !this.value && this._options.length > 0 ? (this.value = this._options[0].value, this.selectedIndex = 0) : this.selectedIndex = this._options.findIndex((s) => s.value === this.value), this.selectedOptions = (t = this.inputRef.value) == null ? void 0 : t.selectedOptions;
  }
  render() {
    const e = `pkt-input ${this.fullwidth ? "pkt-input--fullwidth" : ""}`;
    return a`
      <pkt-input-wrapper
        ?counter=${this.counter}
        ?disabled=${this.disabled}
        ?hasError=${this.hasError}
        ?hasFieldset=${this.hasFieldset}
        ?inline=${this.inline}
        ?optionalTag=${this.optionalTag}
        ?requiredTag=${this.requiredTag}
        useWrapper=${this.useWrapper}
        ariaDescribedBy=${n(this.ariaDescribedBy)}
        class="pkt-select"
        errorMessage=${n(this.errorMessage)}
        forId=${this.id + "-input"}
        helptext=${n(this.helptext)}
        helptextDropdown=${n(this.helptextDropdown)}
        helptextDropdownButton=${n(this.helptextDropdownButton)}
        label=${n(this.label)}
        optionalText=${n(this.optionalText)}
        requiredText=${n(this.requiredText)}
        tagText=${n(this.tagText)}
      >
        <select
          class=${e}
          aria-invalid=${this.hasError}
          aria-errormessage=${`${this.id}-error`}
          aria-labelledby=${n(this.ariaLabelledby)}
          ?disabled=${this.disabled}
          id=${this.id + "-input"}
          name=${(this.name || this.id) + "-input"}
          value=${this.value}
          @change=${(t) => {
      this.touched = !0, this.value = t.target.value, t.stopImmediatePropagation();
    }}
          @input=${(t) => {
      this.onInput(), t.stopImmediatePropagation();
    }}
          @focus=${(t) => {
      this.onFocus(), t.stopImmediatePropagation();
    }}
          @blur=${(t) => {
      this.onBlur(), t.stopImmediatePropagation();
    }}
          ${d(this.inputRef)}
        >
          ${this._options.length > 0 ? this._options.map(
      (t) => a`<option
                    value=${t.value}
                    ?selected=${this.value == t.value || t.selected}
                    ?disabled=${t.disabled}
                    ?hidden=${t.hidden}
                  >
                    ${t.label}
                  </option>`
    ) : ""}
        </select>
        <div class="pkt-contents" ${d(this.helptextSlot)} name="helptext" slot="helptext"></div>
      </pkt-input-wrapper>
    `;
  }
  returnNumberOrNull(e) {
    return e == null || isNaN(e) ? null : e;
  }
};
f([
  c({ type: String })
], r.prototype, "value", 2);
r = f([
  _("pkt-select")
], r);
export {
  r as P
};
